import { dataOutstanding } from 'dls-icons-data'
import { createIcon } from '../common'

const IconOutstanding = /*#__PURE__*/createIcon(dataOutstanding)
export default IconOutstanding
